export default {
  install: app => {
    const r = require.context('../components', false, /\.vue$/);
    r.keys().forEach(fileName => {
      app.component('app-' + fileName.slice(2, -4), r(fileName).default);
    });
  }
};
